import { render } from "./MemberTop.vue?vue&type=template&id=070ce96a&scoped=true"
import script from "./MemberTop.vue?vue&type=script&lang=js"
export * from "./MemberTop.vue?vue&type=script&lang=js"

import "./MemberTop.vue?vue&type=style&index=0&id=070ce96a&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070ce96a"]])

export default __exports__